// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-module__container--4-agB"};